import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState as C, useRef as y, useCallback as a } from "react";
var k = "0px",
    p = [0];

function w() {
  var o = /* @__PURE__ */new Map();

  function b(_ref) {
    var c = _ref.root,
        s = _ref.rootMargin,
        u = _ref.threshold;
    var r = o.get(c);
    r || (r = /* @__PURE__ */new Map(), o.set(c, r));
    var i = JSON.stringify({
      rootMargin: s,
      threshold: u
    });
    var e = r.get(i);

    if (!e) {
      var n = /* @__PURE__ */new Map();
      e = {
        observer: new IntersectionObserver(function (R) {
          R.forEach(function (v) {
            var t = n.get(v.target);
            t == null || t(v);
          });
        }, {
          root: c,
          rootMargin: s,
          threshold: u
        }),
        entryCallbacks: n
      }, r.set(i, e);
    }

    return {
      observe: function observe(n, l) {
        e == null || e.entryCallbacks.set(n, l), e == null || e.observer.observe(n);
      },
      unobserve: function unobserve(n) {
        e == null || e.entryCallbacks.delete(n), e == null || e.observer.unobserve(n);
      }
    };
  }

  return {
    getObserver: b
  };
}

var M = w();

function T(o) {
  var _ref2, _ref3;

  var b = (_ref2 = o == null ? void 0 : o.rootMargin) !== null && _ref2 !== void 0 ? _ref2 : k,
      c = (_ref3 = o == null ? void 0 : o.threshold) !== null && _ref3 !== void 0 ? _ref3 : p,
      s = y(null),
      u = y(null),
      r = y(null),
      _C = C(),
      _C2 = _slicedToArray(_C, 2),
      i = _C2[0],
      e = _C2[1],
      n = a(function () {
    var t = s.current;

    if (!t) {
      e(void 0);
      return;
    }

    var f = M.getObserver({
      root: u.current,
      rootMargin: b,
      threshold: c
    });
    f.observe(t, function (E) {
      e(E);
    }), r.current = f;
  }, [b, c]),
      l = a(function () {
    var t = r.current,
        f = s.current;
    f && (t == null || t.unobserve(f)), r.current = null;
  }, []),
      R = a(function (t) {
    l(), s.current = t, n();
  }, [n, l]),
      v = a(function (t) {
    l(), u.current = t, n();
  }, [n, l]);

  return [R, {
    entry: i,
    rootRef: v
  }];
}

function V(o) {
  var i;

  var _T = T(o),
      _T2 = _slicedToArray(_T, 2),
      b = _T2[0],
      c = _T2[1],
      s = !!((i = c.entry) != null && i.isIntersecting),
      _C3 = C(s),
      _C4 = _slicedToArray(_C3, 2),
      u = _C4[0],
      r = _C4[1];

  return s && !u && r(!0), [b, _objectSpread(_objectSpread({}, c), {}, {
    isVisible: s,
    wasEverVisible: u
  })];
}

export { w as createObserverCache, V as useTrackVisibility };